import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalPasscodeInquiryComponent } from './modal-passcode-inquiry.component';

@NgModule({
  imports: [CommonModule, IonicModule, FormsModule, ReactiveFormsModule],
  declarations: [ModalPasscodeInquiryComponent],
})
export class ModalPasscodeInquiryModule {}
